import "../src/global/global-pc"
import "@modules/advert-cards/advert-cards"

import "@modules/browser-extension/open-with-gesamt-icons.css"

import "@modules/tracking/previous-next-advert-cookie"

import "@modules/top-adverts/top-adverts"

import "@modules/azm"
import "@modules/azm/anzeigenmarkt-styles-pc.css"
import "@modules/azm/not-found-azm.css"

import "@modules/vue-modals/ad-free"
import "@modules/vue-modals/age-verification.js"
import "@modules/vue-modals/coins"
import "@modules/location/LocationSelector"
import "@modules/solads/solads"
import "@modules/stars-top-creator-stripe/starsTopCreatorStripeIndex.ts"

import { setFilterPathLocationToSessionStorage } from "@modules/global/filter-path/filter-path-handler.ts"
setFilterPathLocationToSessionStorage("azm")
